import AdminDistrictProfile from './AdminDistrictProfile';
export default AdminDistrictProfile;
